<template>
  <div>
    <!-- <button class="btn btn-primary" v-bind:disabled="prevIndex == -1" @click="$emit('index-changed', prevIndex)">prev</button> -->
    <a v-bind:href="prevIndex"  @click="indexChanged(prevIndex, $event)" class="swipe-but"><font-awesome-icon icon="angle-left" /></a>
    <span class="noselect">{{ currentIndex + 1 }} / {{ maxlength }}</span>
    <!-- <button class="btn btn-primary" v-bind:disabled="nextIndex == maxlength" >next</button> -->
    <a v-bind:href="nextIndex" @click="indexChanged(nextIndex, $event)" class="swipe-but"><font-awesome-icon icon="angle-right" /></a>
  </div>
</template>

<script>
import { GlobalState } from "../utils/GlobalState";

export default {
  name: "SwiperNavigation",
  props: {
    maxlength: Number,
    index: Number,
  },
  methods: {
    indexChanged(idx, e) {
      if (idx >= 0 && idx < this.maxlength) {
        GlobalState.$emit("nav-changed", idx);
      }
      e.preventDefault()
      return false
    },
  },
  computed: {
    prevIndex: function () {
      return (this.index - 1) >= 0 ? this.index - 1 : 0;
    },
    nextIndex: function () {
      return (this.index + 1) < this.maxlength ? this.index + 1 : ( this.maxlength - 1);
    },
    currentIndex: function () {
      return this.index;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fa-angle-right {
  margin-left: 8px;
  cursor: pointer;
}
.fa-angle-left {
  margin-right: 8px;
  cursor: pointer;
}
.swipe-but {
  color: unset;
}
</style>
